import { post,get,getJ,put,deleteJ,getExcel,uploadFile,uploadSort,upload,postOther,getPDF,deletes,importExcel } from '@/utils/axios'

export default {
    
    InsuranceCompanyAdd(datas){
        return post('InsuranceCompany/InsuCopmayAdd',datas)
    },
    InsuranceCompanyEdit(datas){
        return post('InsuranceCompany/InsuCopmayEdit',datas)
    },
    InsuranceCompanyDel(datas){
        return post('InsuranceCompany/InsuCopmayDel',datas)
    },
    InsuranceCompanyList(datas){
        return get('InsuranceCompany/insuCopmayList',datas)
    },
    
}